export default "__VITE_PUBLIC_ASSET__9f5510af__"